import { Button } from "./Button";
import Section from "./Section";
import Heading from "./Heading";

export const CTABox = ({ roundedBorder = true, borderColor = "lupine-100", border = true }) => {
  const borderColorClass = `border-${borderColor}`;
  const roundedClass = roundedBorder ? "rounded-3xl" : "";
  const borderClass = border ? "border" : "";

  return (
      <div
        className={`${borderClass} ${borderColorClass} ${roundedClass} bg-clip-border px-8 md:px-16 py-16 md:py-28 flex flex-col md:flex-row justify-between gap-6 bg-no-repeat bg-top bg-[length:100%]`}
        style={{ backgroundImage: 'url(/images/logos/logo-stroke.svg)' }}
      >
        <Heading level="h2" align="center">
          Automate RFP and RFI responses with Wolfia
        </Heading>
        <Button CTA="Schedule a demo" href="/" variant="primary" width="auto" />
      </div>
  );
};